import ModalBase from "./ModalBase";

export default ModalBase;
